<template>
  <button ref="copyRef" class="qm-copy">
    <template v-if="$slots.default">
      <slot></slot>
    </template>
    <template v-else>
      <template v-if="type === 'icon'">
        <i v-show="status === 'normal'" class="qm-copy__icon qm-icon-copy"></i>
        <i v-show="status === 'success'" class="qm-copy__icon qm-copy__icon--success qm-icon-success-fill"></i>
        <i v-show="status === 'fail'" class="qm-copy__icon qm-copy__icon--fail qm-icon-warning-fill"></i>
      </template>
      <template v-else>
        <span class="qm-copy__reference">复制</span>
      </template>
    </template>
  </button>
</template>

<script>
import Clipboard from 'clipboard'
export default {
  name: 'QmCopy',
  props: {
    type: {
      type: String,
      default: 'icon',
      validator: value => ['icon', 'text'].indexOf(value) !== -1,
    },
    message: {
      type: [String, Number],
    },
    delay: {
      type: Number,
      default: 1500,
      validator: value => value >= 1500,
    },
  },
  data() {
    return {
      status: 'normal',
      clipboardRef: null,
    }
  },
  watch: {
    message: {
      handler() {
        this.$nextTick(() => {
          this.clipboardRef && this.clipboardRef.destroy()
          this.clipboardRef = new Clipboard(this.$refs.copyRef, { text: () => this.message })
          this.clipboardRef.on('success', event => {
            this.status = 'success'
            setTimeout(() => (this.status = 'normal'), this.delay)
            this.$emit('success', event)
          })
          this.clipboardRef.on('fail', event => {
            this.status = 'fail'
            setTimeout(() => (this.status = 'normal'), this.delay)
            this.$emit('fail', event)
          })
        })
      },
      immediate: true,
    },
  },

  beforeDestroy() {
    this.clipboardRef && this.clipboardRef.destroy()
  },
}
</script>
